import { shipmentApiClient } from '../shipmentApiClient'

import { getTenantShipmentsEndpoint } from './endpoint'
import type { GetTenantShipmentsParams, GetTenantShipmentsResponse } from './type'

// クエリパラメータは camelCase で渡し、decamelizeRequestInterceptor が snake_case に変換する
// （driverPhoneNumber → driver_phone_number 等）。undefined の項目は axios が送信時に除外する。
export const getTenantShipments = async (
  params: GetTenantShipmentsParams
): Promise<GetTenantShipmentsResponse> => {
  const { tenantId, ...query } = params
  const res = await shipmentApiClient.get<GetTenantShipmentsResponse>(
    getTenantShipmentsEndpoint(tenantId),
    { params: query }
  )
  return res.data
}
